import { configure } from '@37signals/lexxy'

configure({
  default: {
    // Match the heading levels we exposed under Trix (h1 native, h2/h3 custom).
    headings: ['h1', 'h2', 'h3'],
    // Lexxy's own default. Turning it off routed plain-text pastes down a branch that
    // reads the clipboard after the paste handler has returned, by which point the
    // browser has emptied it, so the paste silently inserted nothing (#1690).
    markdown: true
  }
})
